
import { Controller, useFormContext } from "react-hook-form";
import { DynamicFieldData } from "./dynamic-control-types";
import { Box, Button, Checkbox, Input, Option, Radio, RadioGroup, Select, Switch, Textarea, Typography } from "@mui/joy";
// import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker';
import React, { memo, useEffect } from "react";
import SearchSelect from "@components/SearchSelect";
import { endpointForMorphType, morphTypeForEndpoint } from "@utils/morphTypes";
import { ensureDateObject, formatDateForDatabase, isValidDate } from "@utils/dates";
import { MaterialThemeWrapper } from "theme";
import { DatePicker } from "./DatePicker";
import { TimePicker } from "./TimePicker";
import { useTenant } from "@providers/TenantProvider";
import { useAuth } from "@providers/AuthProvider";
import { getAccessToken } from "api";
import UploadDropZone from "@rpldy/upload-drop-zone";
import UploadButton from "@rpldy/upload-button";
import { FeaturedPhotoPicker } from "./FeaturedPhotoPicker";
import { useRenderCount } from "@uidotdev/usehooks";

// export function DynamicControl({
export const DynamicControl = memo(function DynamicControl({
  type,
  name,
  defaultValue = undefined,
  options = [],
  config = {},
  showRequired = null, // this isn't used, but it's here so it doesn't get called with restProps
  ...restProps
}: DynamicFieldData) {
  const { control, formState, register, setValue, getValues, watch } = useFormContext();
  const { isValid: isFormValid, isSubmitting } = formState;

  const { user } = useAuth();
  const { tenant } = useTenant();
  // const renders = useRenderCount();
  // console.log(`${name} renders: ${renders}`);

  const values = watch();//getValues();

  let generatedProps = {};
  if(typeof defaultValue === 'string') {
    generatedProps.defaultValue = defaultValue;
  } else if(typeof defaultValue === 'function') {
    generatedProps.defaultValue = defaultValue({ user, tenant });
  }

  /*
  useEffect(() => {
    //
    if(generatedProps?.defaultValue && !values[name]) {
      setValue(name, generatedProps.defaultValue);
    }
  }, [])
  */


  /*
  const { control, formState } = useFormContext();
    const { dirtyFields, isSubmitting } = useFormState({
        control
    });
  */

  if(type === 'submit') {
    return (
      <Button
        type="submit"
        disabled={!isFormValid}
        loading={isSubmitting}
      >
        {restProps.buttonLabel}
      </Button>
    );
  }

  if(['text', 'number', 'email', 'password', 'tel'].indexOf(type) !== -1) {
    return (
      <Input
        variant="outlined"
        id={name}
        key={name}
        type={type}
        {...register(name, config)}
        // defaultValue={defaultValue}
        {...restProps}
        {...generatedProps}
        slotProps={{
          input: {
            ...(type === 'number') ? {step: 'any'} : {}, // not working with generated props for some reason
          }
        }}
      />
    )
  }

  if(type === 'textarea') {
    return (
      <Textarea
        variant="outlined"
        minRows={1}
        maxRows={3}
        id={name}
        key={name}
        type={type}
        {...register(name, config)}
        // defaultValue={defaultValue}
        {...restProps}
        {...generatedProps}
      />
    )
  }

  if(type === 'select') {
    if(!restProps.placeholder) {
      restProps.placeholder = 'Choose...';
    }

    const {onChange, ...registered} = register(name, config);
    // console.log(Object.keys(registered));

    return (
      <Select
        variant="outlined"
        id={name}
        {...registered}
        // {...register(name, config)}
        value={values?.[name]}
        multiple={restProps?.multiple}
        onChange={(e, v) => {
          setValue(name, v);
          /*
          console.log(v);
          onChange(e, v);
          */
        }}

        {...restProps}
        {...generatedProps}

        // defaultValue={defaultValue}
        // value={watch(name)}
        // name={name}
      >
        {options.map((o, index) => (
          <Option key={index} value={o.value}>
            {o.label}
          </Option>
        ))}
      </Select>
    );
  }

  if(type === 'checkbox' || type === 'checkboxes') {
    // const {onChange, ...registered} = register(name, config);
    // console.log(Object.keys(registered));

    return (
      <Controller
          // {...register(name, config)}
          name={name}
          control={control}
          // rules={{ required: true }}
          // defaultValue={false}
          render={({ field/*: { onChange, value }*/ }) => (
      <Box>
        {options.map((o) => (
          // <Typography sx={{display: 'inline-block'}}>
          <Checkbox
            {...field}
            disabled={o?.disabled ? o.disabled(values) : false}
            key={o.value}
            color="primary"
            value={o.value}
            // checked={field.}
            // checked={}
            // disableIcon
            label={o.label}
            // variant="solid"
            sx={theme => ({
              px: 2,
              alignItems: 'center',
              // borderWidth: '2px'
              '--variant-borderWidth': '2px',
              '.MuiCheckbox-checkbox': {
                '--variant-borderWidth': '2px',
                '--variant-outlinedBorder': theme.palette.primary[500],
                '--variant-outlinedHoverBg': theme.palette.primary[500],//300
              }
            })}
            /*
            slotProps={{
              action: ({ checked }) => ({
                sx: {
                  ...(checked && {
                    bgcolor: 'background.surface',
                    boxShadow: 'sm',
                    '&:hover': {
                      bgcolor: 'background.surface',
                    },
                  }),
                },
              }),
            }}
            */
          />
          // </Typography>
        ))}
      </Box>
    )}
    />
  );
  }

  if(type === 'boolean' || type === 'date_boolean') {
    let isChecked;
    if(restProps?.reverse === true) {
      // isChecked = !(!!value);
    } else {
      //
    }

    return (
      <Typography sx={{userSelect: 'none'}} component="label" startDecorator={
        <Controller
          // {...register(name, config)}
          name={name}
          control={control}
          // rules={{ required: true }}
          // defaultValue={false}
          render={({ field: { ref, onChange, value } }) => (
        <Switch
          ref={ref}
          variant="solid"
          id={name}
          // type={type}
          // {...register(name, config)}

          // defaultValue={defaultValue}
          // {...onChange}
          onChange={(e) => {
            setValue(name, !(!!value))
            // console.log(e.target.value)
          }}
          checked={restProps?.reverse ? !(!!value) : !!value}
        />
        )}
        />
      }>
        {...restProps.inputLabel ?? ''}
      </Typography>
    )
  }

  if(type === 'segmented') {
    return (<>
      <Controller
          // {...register(name, config)}
          name={name}
          control={control}
          // rules={{ required: true }}
          // defaultValue={false}
          render={({ field/*: { onChange, value }*/ }) => (
      <RadioGroup
        orientation="horizontal"
        aria-labelledby="segmented-controls-example"
        // name={name}
        // value={value ?? null}
        // onChange={onChange}
        {...field}
        sx={{
          display: 'inline-flex',
          minHeight: 48,
          padding: '4px',
          borderRadius: 'sm',
          bgcolor: 'neutral.softBg',
          '--RadioGroup-gap': '4px',
          '--Radio-actionRadius': '4px',
          // boxShadow: 'sm',
        }}
      >
        {/*
        {options.map((o, index) => (
          <Option key={index} value={o.value}>
            {o.label}
          </Option>
        ))}
        */}
        {options.map((o) => (
          <Radio
            key={o.value}
            color="neutral"
            value={o.value}
            disableIcon
            label={o.label}
            variant="plain"
            sx={{
              px: 2,
              alignItems: 'center',
            }}
            slotProps={{
              action: ({ checked }) => ({
                sx: {
                  ...(checked && {
                    bgcolor: 'background.surface',
                    boxShadow: 'sm',
                    '&:hover': {
                      bgcolor: 'background.surface',
                    },
                  }),
                },
              }),
            }}
          />
        ))}
      </RadioGroup>
      )}
      />
    </>);
  }

  if(type === 'date') {
    return (
      <Controller
        {...register(name, config)}
        control={control}
        // rules={{ required: true }}
        // defaultValue={false}
        render={({ field: {/*onChange,*/ ref, ...fieldProps} }) => {
          if(typeof fieldProps.value === 'undefined') {
            // field.value = null;
          }
          // console.log(field);
          // field.value
          /*
          fieldProps.value = ensureDateObject(fieldProps.value);
          if(!isValidDate(fieldProps.value)) {
            // console.log(field.value);
            fieldProps.value = null;//new Date();
          }
          */
          return (
            <Input
              variant="outlined"
              id={name}
              key={name}
              type={'date'}
              // defaultValue={defaultValue}
              {...fieldProps}
            />
          )
        }}
      />
    );
  }

  if(type === 'date-disabled') {
    return (
      <Controller
        {...register(name, config)}
        control={control}
        // rules={{ required: true }}
        // defaultValue={false}
        render={({ field: {onChange, ...fieldProps} }) => {
          if(typeof fieldProps.value === 'undefined') {
            // field.value = null;
          }
          // console.log(field);
          // field.value
          fieldProps.value = ensureDateObject(fieldProps.value);
          if(!isValidDate(fieldProps.value)) {
            // console.log(field.value);
            fieldProps.value = null;//new Date();
          }
          return (
            <DatePicker
              id={name}
              formatDensity="spacious"
              slotProps={{
                field: {
                  clearable: true,
                },
              }}
              onChange={(value) => {
                if(value) {
                  value = formatDateForDatabase(value);
                }
                onChange(value);
              }}
              width={'100%'}
              sx={{
                width: '100%',
                ...(fieldProps?.sx ?? {})
              }}
              {...fieldProps}
            />
          )
        }}
      />
    );
  }
  if(type === 'time') {
    return (
      <Controller
        {...register(name, config)}
        control={control}
        // rules={{ required: true }}
        // defaultValue={false}
        render={({ field: {onChange, ...fieldProps} }) => {
          if(typeof fieldProps.value === 'undefined') {
            // field.value = null;
          }
          // console.log(field);
          // field.value
          fieldProps.value = ensureDateObject(fieldProps.value);
          if(!isValidDate(fieldProps.value)) {
            // console.log(field.value);
            fieldProps.value = null;//new Date();
          }
          return (
            <TimePicker
              id={name}
              formatDensity="spacious"
              slotProps={{
                field: {
                  clearable: true,
                },
              }}
              onChange={(value) => {
                if(value) {
                  value = formatDateForDatabase(value);
                }
                onChange(value);
              }}
              {...fieldProps}
            />
          )
        }}
      />
    );
  }

  if(type === 'relationship') {
    // console.log(restProps);
    let hydrateWith = [];
    const loadAll = restProps?.loadAll ?? false;
    const polymorphicName = restProps?.polymorphic_name ?? null;
    const valueEndpoint = polymorphicName ? endpointForMorphType(values?.[polymorphicName]) : null;

    if(restProps.defaultProp) {
      let checkVal = values?.[restProps.defaultProp];
      if(checkVal) {
        hydrateWith.push(polymorphicName ? {...checkVal, __endpoint: valueEndpoint} : checkVal);
      }
    }

    // console.log(hydrateWith);


    // TODO: HANDLE DIFFERENTLY FOR MULTIPLE
    let propsForMultiple = {
      getOptionLabel: (option) => option.name,
      // defaultValue={[top100Films[13]]}
    };

    // const hydrateWith = restProps.defaultProp ? values?.[restProps.defaultProp] : [];
    return (<>
      <Controller
        name={name}
        control={control}
        rules={config}
        // rules={{ required: true }}
        render={({ field: {onChange, /*ref,*/ ...fieldProps} /*: {name, onChange}*/ }) => (
          <SearchSelect
            {...fieldProps}
            endpoint={restProps.endpoint}
            valueEndpoint={valueEndpoint}
            hydrateWith={hydrateWith}
            loadAll={loadAll}
            multiple={restProps?.multiple}
            groupBy={restProps?.groupBy}
            onChange={(val, objVal) => {
              onChange(val);

              if(polymorphicName) {
                setValue(polymorphicName, morphTypeForEndpoint(objVal?.__endpoint));
              }
            }}
          />
        )}
      />
    </>)
  }

  if(type === 'demographics') {
    let suffix = restProps?.suffix ?? '';
    const demographicsTypes = [
      {name: 'is_veteran', label: 'Veteran'+suffix},
      {name: 'is_minority', label: 'Minority'+suffix},
      {name: 'is_female', label: 'Woman'+suffix},
      {name: 'is_lgbt', label: 'LGBTQ'+suffix},
    ];

    return (<>
      {demographicsTypes.map((demographic, index) => (<React.Fragment key={index}>
        <Typography sx={{userSelect: 'none'}} component="label" startDecorator={
            <Controller
              // {...register(demographic.name, config)}
              name={demographic.name}
              control={control}
              render={({ field: { ref, onChange, value } }) => (
                <Switch
                  ref={ref}
                  variant="solid"
                  id={demographic.name}
                  // {...field}
                  onChange={(e) => {
                    setValue(demographic.name, value ? 0 : 1);// !value)
                  }}
                  // checked={value}
                  checked={!!values?.[demographic.name]}
                />
              )}
            />
          }>
            {demographic.label}
          </Typography>
      </React.Fragment>))}
    </>);
  }

  if(type === 'file') {
    const url = restProps?.url(values);
    return (<>
      <FeaturedPhotoPicker url={url} scope={restProps?.scope} showPending={restProps?.showPending} />
    </>)
  }

  return <>unsupported field: {type}</>
// };
});
